import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JsonataPipe } from '@assess/browser/dynamic/components';

import { DataMartApiConfiguration } from '../data-mart-api-configuration';

@Injectable({ providedIn: 'root' })
export class DatamartCrudService {
  constructor(
    private readonly http: HttpClient,
    private readonly config: DataMartApiConfiguration
  ) {}

  execute<Type>(query: string, expression: string): Observable<Type> {
    return this.http.post(`${this.config.graphQlUrl}`, { query }).pipe(
      switchMap(async (response) => {
        const jsonataPipe = new JsonataPipe();

        const result = (await jsonataPipe.transform(response, expression)) as Type;

        return result;
      })
    );
  }
}
